export const links = [
    {
        text: "Tutorial",
        url: "https://www.gatsbyjs.com/docs/tutorial",
        description:
            "A great place to get started if you're new to web development. Designed to guide you through setting up your first Gatsby site.",
    },
    {
        text: "Examples",
        url: "https://github.com/gatsbyjs/gatsby/tree/master/examples",
        description:
            "A collection of websites ranging from very basic to complex/complete that illustrate how to accomplish specific tasks within your Gatsby sites.",
    },
    {
        text: "Plugin Library",
        url: "https://www.gatsbyjs.com/plugins",
        description:
            "Learn how to add functionality and customize your Gatsby site or app with thousands of plugins built by our amazing developer community.",
    },
    {
        text: "Build and Host",
        url: "https://www.gatsbyjs.com/cloud",
        description:
            "Now you’re ready to show the world! Give your Gatsby site superpowers: Build and host on Gatsby Cloud. Get started for free!",
    },
];

export const samplePageLinks = [
    {
        text: {
            en: "HOME",
            ua: "ДОДОМУ"
        },
        url: "/",
        description: "",
    },
    {
        text: {
            en: "BULLETIN",
            ua: "ЩО НОВОГО"
        },
        url: "/bulletin",
        badge: false,
        description: "Current week church bulletin",
    },
    {
        text: {
            en: "SCHEDULE",
            ua: "РОЗКЛАД"
        }, url: "/schedule"
    },
    {
        text: {
            en: "EVENTS",
            ua: "ПОДІЇ"
        }, url: "/events"
    },
    {
        text: {
            en: "ABOUT",
            ua: "ПРО ЦЕРКВУ"
        }, url: "/about"
    },
    {
        text: {
            en: "CHOIR",
            ua: "ХОР"
        }, url: "/choir"
    },
    {
        text: {
            en: "PRAYER",
            ua: "МОЛИТВА"
        }, url: "/prayer"
    },
    {
        text: {
            en: "CONTACT",
            ua: "ЗВ'ЯЗАТИСЬ"
        }, url: "/contact"
    },
];

export const LANGUAGE_ID = {
    en: "en",
    ua: "ua",
};

export const LANGUAGE_ICON = {
    en: "🇺🇸",
    ua: "🇺🇦",
}

export const LANGUAGES = [LANGUAGE_ID.en, LANGUAGE_ID.ua];